import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  hdng: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: 24,
    margin: "19px 0px 17px 0px",
    fontWeight: 700,
  },
  infoBox: {
    minHeight: 52,
    borderRadius: "8px",
    border: "1px solid #E4E4E7",
    background: "#FFF",
    padding: "4px 12px",
    alignItems: "center",
    gap: 10,
    "& svg": {
      width: 34,
      height: 34,
    },
    "& .mantine-Text-root": {
      color: "#0F172A",
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 400,
    },
  },
  content: {
    background: "#FFF",
    borderRadius: "10px",
    padding: "0px 14px",
    marginBlock: 17,
    minHeight: 574,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "@media (max-width: 600px)": {
      padding: "0px 8px",
      minHeight: "unset",
    },
  },
  optionsParent: {
    margin: "14px 20px",
    "@media (max-width: 600px)": {
      margin: "14px 8px",
    },
  },
  option: {
    width: "100%",
    maxWidth: "700px",
    paddingBlock: 15,
    paddingRight: 45,
    marginTop: 16,
    alignItems: "center",
    justifyContent: "space-between",
    gap: 20,
    borderBottom: "0.5px solid #A8A8A8",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      paddingRight: 0,
    },
    "& .title": {
      marginBottom: 4,
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 500,
      color: "#101828",
    },
    "& .discription": {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 400,
      color: "#0F172A",
    },
   "& .data": {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 800,
      color: "#FFAF4A",
      marginTop:'5px'
    },

    '& .mantine-Checkbox-input:checked':{
        backgroundColor: "#27272A",
        borderColor: "#27272A"
    },
  },
  resetBtn:{
    height: 28,
    padding: "0px 12px",
    borderRadius: 16,
    backgroundColor: '#F2F4F7',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 14,
    fontFamily: "Inter",
    fontWeight: 500,
    color: "#344054"
  },
  bottom:{
    width: "100%",
    padding: "18px 20px",
    borderTop: '1px solid #E5E5E5',
    gap: 12
  },
  saveBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 60,
    flex: 1,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#171717",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  cancelBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #F5F5F5",
    backgroundColor: "#F5F5F5",
    height: 60,
    flex: 1,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#e9e9e9",
      opacity: 0.8,
    },
  },
}));

export default useStyles;
